import moment from 'moment';

export const calculateTimeDifference = (endsAt: Date): number => {
  const startTime = moment();
  const endTime = moment(endsAt);
  return endTime.diff(startTime);
};
